import React from "react";

import { TableSearch } from "ui/components/Table/TableSearch";
import { useSelectedItemsChanges } from "ui/components/Table/hooks";
import { TextField } from "ui/components/TextField/TextField";
import { TextArea } from "ui/components/TextField/TextArea";
import { useHandleTextFieldChange } from "services/forms/hooks";
import { useTranslate } from "helpers";

import { AdditionalEquipment, NewPriceFormValues } from "services/api/catalog/cvh/types";
import { EQUIPMENT_COLUMNS_SEARCH_COLUMNS } from "../consts";


interface NewPriceEquipmentFormProps {
  equipment: AdditionalEquipment[];
  equipmentLoading: boolean;
  selectedEquipment: number[];
  setSelectedEquipment: React.Dispatch<React.SetStateAction<number[]>>;
  formValues: NewPriceFormValues;
  setFormValues: React.Dispatch<React.SetStateAction<NewPriceFormValues>>;
}

const NewPriceEquipmentForm: React.FC<NewPriceEquipmentFormProps> = ({
  equipment,
  equipmentLoading,
  selectedEquipment,
  setSelectedEquipment,
  formValues,
  setFormValues,
}) => {
  const { t } = useTranslate();
  const handleSelectedChange = useSelectedItemsChanges(selectedEquipment, setSelectedEquipment);
  const handleTextFieldChange = useHandleTextFieldChange(setFormValues, formValues);

  return (
    <div className="p-4">
      {equipmentLoading ? (
        <div className="text-center py-8 text-gray-500">Učitavanje dodatne opreme...</div>
      ) : equipment.length === 0 ? (
        <div className="text-center py-8 text-gray-500">Nema dostupne dodatne opreme za ovaj JOM</div>
      ) : (
        <>
          <div className="flex items-center gap-2 mb-2">
            <span className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
              <span className="w-2 h-2 rounded-full bg-green-500" />
              <span>Uključena oprema</span>
            </span>
          </div>
          <div className="max-h-[50vh] overflow-y-auto mb-6 border border-slate-200 px-3">
            <TableSearch
              data={equipment}
              columns={EQUIPMENT_COLUMNS_SEARCH_COLUMNS}
              selectableRows={true}
              selectedRows={selectedEquipment}
              onSelectedChange={handleSelectedChange}
              disablePagination={true}
              showSelectAll={true}
            />
          </div>
        </>
      )}

      <div className="flex flex-col gap-3 mt-4">
        <div className="mb-3">
          <TextField
            type="number"
            name="additionalEquipmentFreePrice"
            label={t("admin.fleet.vehicle.residualvalue.additionalequipmentfreeprice")}
            placeholder={t("admin.fleet.vehicle.residualvalue.additionalequipmentfreeprice.placeholder")}
            value={formValues.additionalEquipmentFreePrice ?? ""}
            onChange={handleTextFieldChange}
            groupAppend="€"
          />
        </div>
        <div className="mb-3 col-span-3">
          <TextArea
            rows={3}
            name="additionalEquipmentFreeText"
            label={t("admin.fleet.vehicle.residualvalue.additionalequipmentfreetext")}
            placeholder={t("admin.fleet.vehicle.residualvalue.additionalequipmentfreetext.placeholder")}
            value={formValues.additionalEquipmentFreeText ?? ""}
            onChange={handleTextFieldChange}
          />
        </div>
      </div>
    </div>
  );
};

export default NewPriceEquipmentForm;
